import React from "react";
import { reportsActions } from "../../_store/reports.slice";
import { GenerateOrderBaseReport } from "../reports/GenerateOrderBaseReport";
import { FormControl } from "../../_components/Forms/FormControl";
import { HorizontalView } from "../../_components/Abstractions/HorizontalView";
import { ContractorSelect } from "../../_components/Contractors/ContractorSelect";

export function GenerateRatePlanChangesReport() {
  const renderData = (data) => {
    const items = data ?? [];

    if (!items || items.length === 0 || items.loading) {
      return <div className="mt-2">Brak zmian</div>;
    }

    return (
      <div className="mt-2">
        <div className="table-responsive">
          <table className="table table-sm table-striped">
            <thead>
            <tr>
              <th>Kontrahent</th>
              <th>Adres</th>
              <th>Użytkownik</th>
              <th>Data modyfikacji</th>
              {/*<th>RatePlanId</th>*/}
              {/*<th>HistoryId</th>*/}
              <th>Zmiany</th>
            </tr>
            </thead>
            <tbody>
            {items.map((entry) => (
              <tr key={entry.historyId ?? `${entry.ratePlanId}-${entry.createdAt}`}>
                <td>{entry.contractorName ? entry.contractorName.toUpperCase() : "-"}</td>
                <td>{entry.addressName ? entry.addressName.toUpperCase() : "-"}</td>
                <td>{entry.userLogin ? entry.userLogin.toUpperCase() : "-"}</td>
                <td>{entry.createdAt ? new Date(entry.createdAt).toLocaleString() : "-"}</td>
                {/*<td>{entry.ratePlanId ?? "-"}</td>*/}
                {/*<td>{entry.historyId ?? "-"}</td>*/}
                <td>
                  {entry.changeEntries && entry.changeEntries.length > 0 ? (
                    <ul className="mb-0">
                      {entry.changeEntries.map((ce, idx) => (
                        <li key={idx} style={{ listStyle: "none", padding: 0 }}>
                          {ce.field ? `${ce.field}: ${ce.oldValue} -> ${ce.newValue}` : JSON.stringify(ce)}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <span className="text-muted">Brak szczegółów</span>
                  )}
                </td>
              </tr>
            ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  return (
    <GenerateOrderBaseReport
      reportTitle="Raport zmian cenników"
      reportType="ratePlanChanges"
      renderData={renderData}
      customControls={<GenerateRatePlanChangesFilters />}
      renderDefaultControls={false}
      reportAction={reportsActions.generateRatePlanChangesReport}
    />
  );
}

const GenerateRatePlanChangesFilters = () => {
  return (
    <div className="d-flex flex-column align-items-start">
      <div className="mt-2">
        <HorizontalView>
          <FormControl name="dateFrom" label="Dzień od" inputType="date" />
          <FormControl name="dateTo" label="Dzień do" inputType="date" />
          <ContractorSelect name="contractorId" saveWholeObject={false} />
        </HorizontalView>
      </div>
    </div>
  );
};
